
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import PodLoadingState from "../components/PodLoadingState";
import PodErrorState from "../components/PodErrorState";
import PodNotFoundState from "../components/PodNotFoundState";
import PodDetails from "../components/PodDetails";

interface PodData {
  name: string;
  address: string;
  price_per_minute: string;
  in_use: boolean;
}

const Pods = () => {
  const { pod_id } = useParams<{ pod_id: string }>();

  const { data: pod, isLoading, error } = useQuery({
    queryKey: ['pod-details', pod_id],
    queryFn: async () => {
      if (!pod_id) throw new Error('Pod ID is required');
      
      const response = await fetch(`https://qwipsvc.up.railway.app/api/pod?pod_id=${pod_id}`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch pod details');
      }
      
      const data: PodData = await response.json();
      return data;
    },
    enabled: !!pod_id,
  });

  if (error) {
    console.error('Error fetching pod details:', error);
  }

  if (isLoading) {
    return <PodLoadingState />;
  }

  if (error) {
    return <PodErrorState />;
  }

  if (!pod) {
    return <PodNotFoundState />;
  }

  return <PodDetails pod={pod} />;
};

export default Pods;
